import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="relative w-full h-fit py-14 bg-black text-white">
      <div className="relative w-full h-full px-[calc((100%-var(--container))/2)] lg:flex items-start justify-between">
        <div className="relative w-full h-full">
          <p className="lg:text-3xl mb-8">Sarah's Coffee</p>
          <ul className="grid gap-3">
            <li>
              <small>전라남도 진도군 임회면 상만리 236-12</small>
              <br />
              <small>전라남도 진도군 고군면 오일시2길 116</small>
            </li>
            <li>
              <small className="opacity-60">
                COPYRIGHT © 2025 Sarah'sCoffee ALL RIGHTS RESERVED.
              </small>
              <Link
                to={"/admin/login"}
                className=" relative w-fit h-fit text-xs pb-0.5 px-3 ml-2 mt-2 lg:mt-0 border rounded-md hover:bg-white hover:text-black"
              >
                <small>관리자</small>
              </Link>
            </li>
          </ul>
        </div>
        <div className="relative w-fit h-full">
          <ul className="flex items-center gap-5">
            <li>
              <a href="#">
                <small className="hoverLine">개인정보처리방침</small>
              </a>
            </li>
            <li>
              <a href="#">
                <small className="hoverLine">이용약관</small>
              </a>
            </li>
            <li>
              <a href="#">
                <small className="hoverLine">문의하기</small>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
